import { XCircleIcon } from '@heroicons/react/20/solid'

export const Alert = ({ error }: { error: string }) => {
  return (
    <div className="absolute top-10 z-30 rounded-md bg-red-50 p-4">
      <div className="flex">
        <div className="shrink-0">
          <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium text-red-800">{error}</p>
        </div>
      </div>
    </div>
  )
}
